import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { GetSearchCategories } from './search.actions';
import { SearchState } from './search.state';

@Injectable({
    providedIn: 'root'
})
export class SearchFacade {
    categories$ = this.store.select(SearchState.categories);
    imageCategories$ = this.store.select(SearchState.imageCategories);
    constructor(private store: Store) {}

    getMenu() {
        return this.store.dispatch(new GetSearchCategories());
    }
}
